
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";
import "./Login.css";

export default function Login() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState("");
  const [cargando, setCargando] = useState(false);

  // Actualizar los campos del formulario
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  // Iniciar sesión
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (cargando) return;

    setError("");
    setCargando(true);

    try {
      const respuesta = await fetch(
        `${API}/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(form),
        }
      );

      const datos = await respuesta.json();

      if (!respuesta.ok) {
        throw new Error(
          datos.error || "No se pudo iniciar sesión."
        );
      }

      // Comprobar los datos de autenticación
      if (!datos.token) {
        throw new Error(
          "El servidor no devolvió un token de autenticación."
        );
      }

      if (!datos.usuario) {
        throw new Error(
          "El servidor no devolvió los datos del usuario."
        );
      }

      // Identificar la pantalla según el rol
      let destino;

      if (datos.usuario.rol === "Administrador") {
        destino = "/dashboard";
      } else if (datos.usuario.rol === "Conductor") {
        destino = "/panel-conductor";
      } else if (datos.usuario.rol === "Finanzas") {
        destino = "/dashboard";
      } else {
        throw new Error("Rol de usuario no reconocido.");
      }

      // Guardar la sesión en esta pestaña
      sessionStorage.setItem(
        "usuario",
        JSON.stringify(datos.usuario)
      );

      sessionStorage.setItem("token", datos.token);

      // Eliminar credenciales antiguas
      localStorage.removeItem("usuario");
      localStorage.removeItem("token");

      // Redirigir al usuario
      navigate(destino, { replace: true });

    } catch (err) {
      setError(
        err.message || "Ocurrió un error al iniciar sesión."
      );
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">

        {/* Identidad del sistema */}
        <div className="login-logo" aria-hidden="true">
          TF
        </div>

        <h1>Transportes Figueroa</h1>

        <p className="login-subtitulo">
          Sistema de asignación y control de viáticos
          <br />
          Ingresa tus credenciales para continuar.
        </p>

        {/* Formulario de acceso */}
        <form onSubmit={handleSubmit}>

<div className="form-group">
  <label htmlFor="login-email">
    Nombre de usuario
  </label>

  <input
    id="login-email"
    type="text"
    name="email"
    placeholder="Ingrese su nombre de usuario"
    value={form.email}
    onChange={handleChange}
    autoComplete="username"
    required
  />
</div>

          <div className="form-group">
            <label htmlFor="login-password">
              Contraseña
            </label>

            <input
              id="login-password"
              type="password"
              name="password"
              placeholder="Ingrese su contraseña"
              value={form.password}
              onChange={handleChange}
              autoComplete="current-password"
              required
            />
          </div>

          {/* Mensaje de error */}
          {error && (
            <div
              className="login-error"
              role="alert"
            >
              {error}
            </div>
          )}

          {/* Botón de inicio de sesión */}
          <button
            type="submit"
            disabled={cargando}
          >
            {cargando
              ? "Verificando..."
              : "Iniciar sesión"}
          </button>

        </form>

        <p className="login-footer">
          Transportes Figueroa
          <br />
          Sistema de gestión de viáticos
        </p>

      </div>
    </div>
  );
}
